import React, { useState } from "react";
import SEO from "../components/seo";
import SiteLayout from "../components/site/SiteLayout";
import EditLink from "../components/site/EditLink";
import api from "../api";
import { useContato, whatsappLink } from "../lib/contato";

export default function Contato() {
  const page = useContato();
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState(null); // { ok: bool, text: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const nome = form.nome.value.trim();
    const telefone = form.telefone.value.trim();
    const mensagem = form.mensagem.value.trim();
    const website = form.website.value;

    // honeypot: finge sucesso para o bot, mas não envia nada
    if (website) {
      setMsg({ ok: true, text: "Recebido." });
      form.reset();
      return;
    }

    setSending(true);
    setMsg(null);
    try {
      await api.post("/email", {
        to: page.emailDestino || page.email,
        from: telefone,
        message: `Nome: ${nome}\nTelefone: ${telefone}\nMensagem: ${mensagem}\nOrigem: Site Bivver — Contato`,
      });
      setMsg({ ok: true, text: page.mensagemSucesso });
      form.reset();
    } catch (error) {
      setMsg({ ok: false, text: page.mensagemErro });
    }
    setSending(false);
  };

  return (
    <SiteLayout>
      <SEO
        lang="pt-BR"
        keywords={[`Bivver`, `Contato`, `WhatsApp`, `corretor`]}
        description="Fale com a Bivver Empreendimentos: WhatsApp, e-mail e endereço. Deixe sua mensagem e um corretor entra em contato."
        title="Contato — Bivver Empreendimentos"
      />

      <EditLink to="/edicao/contato" />

      <section className="contact-page">
        <h1 className="contact-page-title">{page.titulo}</h1>
        <p className="contact-page-sub">{page.subtitulo}</p>

        <div className="contact-grid">
          <a
            className="contact-card"
            href={whatsappLink(page.whatsapp, page.whatsappMensagem)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="contact-card-label">{page.labelWhatsapp}</span>
            <span className="contact-card-value">{page.whatsappLabel}</span>
          </a>
          <a className="contact-card" href={`mailto:${page.email}`}>
            <span className="contact-card-label">{page.labelEmail}</span>
            <span className="contact-card-value">{page.email}</span>
          </a>
          <div className="contact-card contact-card-static">
            <span className="contact-card-label">{page.labelEndereco}</span>
            <span className="contact-card-value">{page.enderecoCurto}</span>
          </div>
        </div>

        <div className="contact-page-form">
          <div className="form-sub">{page.tituloFormulario}</div>
          <form id="lead-form" autoComplete="off" onSubmit={handleSubmit}>
            <input
              type="hidden"
              name="empreendimento"
              value="Site Bivver — Contato"
            />
            <input
              type="text"
              name="website"
              style={{ position: "absolute", left: "-9999px" }}
              tabIndex="-1"
              autoComplete="off"
            />
            <div className="form-field">
              <input type="text" name="nome" placeholder="Nome completo" required />
            </div>
            <div className="form-field">
              <input
                type="tel"
                name="telefone"
                placeholder="WhatsApp / Telefone"
                required
              />
            </div>
            <div className="form-field">
              <textarea name="mensagem" placeholder="Sua pergunta" rows="4" />
            </div>
            <button type="submit" className="btn-submit" disabled={sending}>
              {sending ? "Enviando..." : page.textoBotao}
            </button>
            {msg && (
              <div
                className={`form-msg ${msg.ok ? "ok" : "err"}`}
                id="lead-form-msg"
              >
                {msg.text}
              </div>
            )}
          </form>
        </div>
      </section>
    </SiteLayout>
  );
}
